export default {
    capitalize(value) {
        let text = value;
        if (text) {
            text = text.toLowerCase().replace(/\b[a-z]/g, letter => letter.toUpperCase());
        }
        return text;
    },
};
